import { useTranslation } from 'react-i18next';
import { FileDown } from 'lucide-react';

import type { BookingEventDetail } from '@/types';

import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';

import { cn } from '@/lib/utils';

type RegistrationsFooterProps = {
  event: BookingEventDetail | undefined;
  eventPageUrl?: string;
  exportUrl: string | undefined;
  isWaveUnpicked: boolean;
  isAddDisabled: boolean;
  onAdd: () => void;
};

export const RegistrationsFooter = (props: RegistrationsFooterProps) => {
  const {
    event,
    eventPageUrl,
    exportUrl,
    isWaveUnpicked,
    isAddDisabled,
    onAdd,
  } = props;
  const { t } = useTranslation();

  const isOpenForChanges =
    !!event && event.status === 'scheduled' && !event.completed;

  return (
    // Collapses instead of disappearing: its border and shadow are the body's bottom edge.
    <DialogFooter className={cn('flex-wrap gap-2', !exportUrl && 'py-0!')}>
      {isOpenForChanges && isWaveUnpicked && (
        <span className="text-muted-foreground mr-auto text-sm">
          {t('Pick a wave to add a registration')}
        </span>
      )}

      {!!exportUrl && (
        <Button
          variant="outline"
          asChild
        >
          <a
            href={exportUrl}
            download
          >
            <FileDown className="size-4" />
            {t('Export CSV')}
          </a>
        </Button>
      )}

      {isOpenForChanges && (
        <>
          {!!eventPageUrl && (
            <Button
              variant="outline"
              asChild
            >
              <a href={`${eventPageUrl}/${event.id}/edit`}>{t('Edit event')}</a>
            </Button>
          )}

          <Button
            onClick={onAdd}
            disabled={isAddDisabled}
          >
            {t('Add registration')}
          </Button>
        </>
      )}
    </DialogFooter>
  );
};
